import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { filtering } from '@shared/constants/filtering';
import { StorageService } from '@shared/services/storage.service';

@Component({
  selector: 'app-device-filter',
  templateUrl: './device-filter.component.html',
  styleUrls: ['./device-filter.component.scss']
})
export class DeviceFilterComponent implements OnInit {

  @Output() filteringElement = new EventEmitter<number>();
  selectedItem = 0;
  filteringTypes: Readonly<any> = filtering;

  constructor(private storage: StorageService) { }

  ngOnInit() {
    const storageItem = this.getStorage();

    if (storageItem !== null) {
      this.selectedItem = storageItem;
    } else {
      this.setStorage();
    }
  }

  filterBy(): void {
    this.setStorage();
    this.filteringElement.emit(this.selectedItem);
  }

  getStorage(): number {
    return JSON.parse(this.storage.getStorage(this.storage.filteringDevices));
  }

  setStorage(): void {
    this.storage.setStorage(JSON.stringify(this.selectedItem), this.storage.filteringDevices);
  }

}
